export async function uploadToS3(uploadUrl: string, file: File, mimeType: string): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': mimeType,
      'x-amz-acl': 'public-read',
      'Cache-Control': 'public, max-age=360000',
    },
    body: file,
  })

  if (!response.ok) {
    throw new Error(`S3 upload failed with status ${response.status}`)
  }
}
